class TierService {
    contentAPIKey = config.contentAPIKey;
    loading = false;

    async fetch(limit = 'all', skip = 0) {
        return new Promise(async (resolve, reject) => {
            try {
                if (this.loading) return;

                this.loading = true;
                var self = this;

                $.ajax({
                    url: '/ghost/api/content/tiers/',
                    method: 'GET',
                    dataType: 'json',
                    data: {
                        key: this.contentAPIKey,
                        limit: limit,
                        skip: skip
                    }

                })
                    .done(function (e) {
                        resolve(e)
                    })
                    .fail(function (e) {
                        reject(e)
                    })
                    .always(function () {
                        self.loading = false;

                    })

            } catch (e) {
                reject(e)
            }
        })
    }
}